import { put, select, takeLatest } from 'redux-saga/effects';
import { PersonalTask } from 'api/personal-tasks';
import { logger } from 'services';
import { fetchStart, fetchSuccess } from '..';
import { fetchPersonalTasks } from '../actions';

function* fetchPersonalTasksSaga() {
  try {
    yield put(fetchStart());

    // personalTasks is already in the store via init api call. No need to fetch again
    // use a selector instead of the api call to get the data
    const data = (yield select(
      (state) => state?.personalTasks?.data || [],
    )) as PersonalTask[];

    yield put(fetchSuccess(data));
  } catch (error) {
    logger.error('getPersonalTasks', { error });
    // TODO::
  }
}

export function* watchFetchPersonalTasksSaga(): Generator {
  yield takeLatest(fetchPersonalTasks.type, fetchPersonalTasksSaga);
}
